<asset-management-summary-card
    *ngFor="let summaryInfo of summaries; trackBy: 'title' | trackByProperty"
    [summaryInfo]="summaryInfo"
></asset-management-summary-card>
